import { deriveErrorResponse, getDetailedErrorMessage, isErrorResponseValid } from "../utils/validation";
import { isTruthy } from "../utils/fp";
import { formatBulkUploadErrors } from "../utils/errorFormatter";
export class TemplateCreationFailed extends Error {
    constructor(error, fallbackMessage = "Failed to create template. Please try again later.") {
        super();
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, TemplateCreationFailed);
        }
        this.name = "TemplateCreationFailed";
        this.message = getDetailedErrorMessage(error, fallbackMessage);
    }
}
function extractStructuredErrors(error) {
    const data = error.response?.data;
    if (!data?.visible_error)
        return [];
    const structured = data?.structured_errors;
    return Array.isArray(structured) ? structured : [];
}
export class UploadSaveFailed extends Error {
    constructor(error, prependMessage = "Failed to create asset(s) from template.") {
        super();
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, UploadSaveFailed);
        }
        this.name = "UploadSaveFailed";
        const structuredErrors = extractStructuredErrors(error);
        if (structuredErrors.length > 0) {
            this.formattedErrors = formatBulkUploadErrors(structuredErrors);
        }
        else {
            const legacyErrors = isErrorResponseValid(error)
                ? deriveErrorResponse(error).filter(isTruthy)
                : [];
            this.formattedErrors = formatBulkUploadErrors(legacyErrors);
        }
        this.parsedErrors = this.formattedErrors.errors;
        this.errorSummary = this.formattedErrors.summary;
        this.message = `${prependMessage} ${this.errorSummary}`;
    }
}
//# sourceMappingURL=errors.js.map